// @flow
import ContactFormJeuConcours from 'components/contact/ContactFormJeuConcours';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import type { formInputsType } from 'types/ContactForm';
import type { StateType, DispatchType } from 'types/Actions';
import type { StateProps, DispatchProps } from 'components/contact/ContactFormJeuConcours';
import { postContactForm, fetchAllContactForm } from 'actions/formActions';
import { displayModal } from 'actions/modalActions';

export default withRouter(
  connect(
    (state: StateType): StateProps => ({
      contactForm: state.formState.contactFormList,
      fetchStatus: state.formState.fetchStatus,
      sendStatus: state.formState.sendStatus
    }),
    (dispatch: DispatchType): DispatchProps => ({
      postContactForm: (formInputs: formInputsType, id: number) => dispatch(postContactForm(formInputs, id)),
      fetchContactForm: () => dispatch(fetchAllContactForm()),
      displayModal: (modalObject: string, content: Object, force: boolean) =>
        dispatch(displayModal(modalObject, content, force))
    })
  )(ContactFormJeuConcours)
);
